import { Person } from "@mui/icons-material";
import { Avatar, AvatarGroup, Box, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  getAvatarColor,
  getAvatarImageSrc,
  getAvatarInitials,
  hasProfilePicture,
} from "../utils/avatarUtils";

const ParticipantsAvatars = ({
  participants = [],
  maxDisplay = 3,
  size = "small",
  showTotal = true,
}) => {
  const { t } = useTranslation();
  const avatarSize = size === "small" ? 24 : 32;
  const fontSize = size === "small" ? "0.75rem" : "0.875rem";

  const wrapperSx = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  };

  if (!participants || participants.length === 0) {
    return (
      <Box sx={wrapperSx}>
        <Tooltip title={t("common.noParticipants")} arrow>
          <Avatar
            sx={{
              width: avatarSize,
              height: avatarSize,
              fontSize,
              bgcolor: "grey.400",
            }}
          >
            <Person />
          </Avatar>
        </Tooltip>
      </Box>
    );
  }

  const uniqueParticipants = participants.reduce((acc, participant) => {
    const cleanParticipant = {
      user_id: participant.user_id || participant.id || Math.random(),
      username: participant.username || participant.user_name || "مستخدم",
      first_name: participant.first_name,
      last_name: participant.last_name,
      email: participant.email,
      profile_picture: participant.profile_picture,
      avatar:
        participant.avatar || participant.profile_image || participant.image,
    };

    const existing = acc.find((p) => p.user_id === cleanParticipant.user_id);
    if (!existing) {
      acc.push(cleanParticipant);
    }
    return acc;
  }, []);

  const totalCount = uniqueParticipants.length;

  return (
    <Box sx={wrapperSx}>
      {/* Keep LTR stacking so AvatarGroup overlap stays readable in Arabic UI */}
      <AvatarGroup
        dir="ltr"
        max={maxDisplay}
        {...(showTotal ? { total: totalCount } : {})}
        sx={{
          justifyContent: "center",
          "& .MuiAvatar-root": {
            width: avatarSize,
            height: avatarSize,
            fontSize,
            border: "2px solid",
            borderColor: "background.paper",
          },
        }}
      >
        {uniqueParticipants.map((participant, index) => (
          <Tooltip
            key={participant.user_id || index}
            title={
              participant.user_name ||
              participant.username ||
              t("common.unknown")
            }
            arrow
          >
            <Avatar
              src={getAvatarImageSrc(participant)}
              sx={{
                bgcolor: hasProfilePicture(participant)
                  ? undefined
                  : getAvatarColor(participant),
                cursor: "pointer",
              }}
            >
              {hasProfilePicture(participant)
                ? undefined
                : getAvatarInitials(participant)}
            </Avatar>
          </Tooltip>
        ))}
      </AvatarGroup>
    </Box>
  );
};

export default ParticipantsAvatars;
